export default {
  isSure: '是否退出系統?',
  tips: '提示'
}
